module.exports = __webpack_public_path__ + "static/media/trash.ef3326b4.svg";